import './variables';
import './functions';
import { wrapperBuilder } from './build';

export const ContributionPaymentWrapper = wrapperBuilder.build();
